import React from 'react';
import { CalendarCheckIcon, Building2Icon, FileTextIcon, PlaneIcon, HeadphonesIcon, HeartHandshakeIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <CalendarCheckIcon className="text-white" size={28} data-id="element-601" />,
    title: 'Treatment Coordination',
    description: 'Complete coordination of your IVF journey from initial consultation through post-treatment care at premier EU clinics.',
    color: 'from-blue-600 to-blue-700'
  }, {
    icon: <Building2Icon className="text-white" size={28} data-id="element-602" />,
    title: 'Clinic Matching',
    description: 'We match you with the perfect clinic based on your specific needs, budget, and treatment requirements.',
    color: 'from-cyan-600 to-cyan-700'
  }, {
    icon: <FileTextIcon className="text-white" size={28} data-id="element-603" />,
    title: 'Legal & Medical Records',
    description: 'Complete handling of legal paperwork, documentation, and seamless transfer of medical records across borders.',
    color: 'from-blue-500 to-blue-600'
  }, {
    icon: <PlaneIcon className="text-white" size={28} data-id="element-604" />,
    title: 'Travel & Accommodation',
    description: 'Complete travel arrangements including flights, accommodation, and local transportation throughout your stay.',
    color: 'from-cyan-500 to-cyan-600'
  }, {
    icon: <HeadphonesIcon className="text-white" size={28} data-id="element-605" />,
    title: 'Personal Coordinator',
    description: 'Dedicated coordinator available 24/7 to support you through every step of your treatment journey.',
    color: 'from-blue-600 to-blue-700'
  }, {
    icon: <HeartHandshakeIcon className="text-white" size={28} data-id="element-606" />,
    title: 'Post-Treatment Support',
    description: 'Ongoing support and coordination for follow-up care after you return home from treatment.',
    color: 'from-cyan-600 to-cyan-700'
  }];
  return <section id="services" className="py-20 bg-gradient-to-b from-slate-50 to-white" data-id="element-607">
      <div className="container mx-auto px-4" data-id="element-608">
        <div className="text-center mb-16" data-id="element-609">
          <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-4" data-id="element-610">
            <span className="text-blue-700 font-semibold text-sm tracking-wide uppercase" data-id="element-611">
              Our Services
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-normal" data-id="element-612">
            Complete{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600 px-1 py-1 inline-block" data-id="element-613">
              Coordination Services
            </span>
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg font-light leading-relaxed" data-id="element-614">
            We handle every aspect of your fertility treatment journey, from
            legal paperwork and clinic selection to post-treatment care.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-615">
          {services.map((service, index) => <div key={index} className="group bg-white border border-slate-100 p-8 rounded-3xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-616">
              <div className={`bg-gradient-to-br ${service.color} p-4 rounded-2xl inline-block mb-6 group-hover:scale-110 transition-transform shadow-lg`} data-id="element-617">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3 tracking-normal" data-id="element-618">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed font-light" data-id="element-619">
                {service.description}
              </p>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-620">
          <a href="/contact" className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-600/30 hover:scale-105 font-medium" data-id="element-621">
            Schedule a Consultation
          </a>
        </div>
      </div>
    </section>;
}